export class TestService {

    async getSampleData(userId: string): Promise<string> {
        return "Data from Service";
    }
}

export const testService = new TestService();